function isObject(obj) {
    return obj !== null && typeof obj === 'object'
}

function isPlainObject(obj) {
    return isObject(obj) && (obj.constructor === Object || obj.constructor === undefined)
}

export default function mergeDeep(target, ...sources) {
    if (!sources.length) return target
    const source = sources.shift()

    if (Array.isArray(target)) {
        if (Array.isArray(source)) {
            target.push(...source)
        } else {
            target.push(source)
        }
    } else if (isPlainObject(target)) {
        if (isPlainObject(source)) {
            for (let key of Object.keys(source)) {
                // if (!target[key]) {
                if (target[key] === undefined) {
                    target[key] = source[key]
                } else {
                    mergeDeep(target[key], source[key])
                }
            }
        } else {
            throw new Error(`Cannot merge object with non-object`)
        }
    } else {
        target = source
    }

    return mergeDeep(target, ...sources)
}

// const Q = {}
//
// const A = {
//     fieldName: {
//         value: false,
//     },
//     secondName: false,
// }
//
// const B = {
//     fieldName: {
//         value: true,
//     },
//     secondName: true,
// }
//
// const C = mergeDeep(Q, A, B)
// console.log('C ', C) // {fieldName: {value: true}, secondName: true}
// console.log('A ', A) // {fieldName: {value: true}, secondName: false}
// console.log('B ', B) // {fieldName: {value: true}, secondName: true}
